import { Action } from 'redux-actions';
import { PapiModuleGroupActionlog } from '@wix/da-papi-types';
import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';

import { GroupActionLogResultSchema } from '../../../../schemas/modules';

import { GROUP_ACTIONLOG_IDS_STREAM, MESSAGES_PER_FETCH } from '../../../../streams';

export default (
  gruser: Gruser,
  moduleId: number,
  moduleData: PapiModuleGroupActionlog
): Action<any>[] => {
  const { hasMore, nextOffset, results } = moduleData;
  const { result, entities } = normalize(results, [GroupActionLogResultSchema]);
  return [
    putEntities({ entities }),
    {
      ...withOffset.actions.initialize({
        streamId: GROUP_ACTIONLOG_IDS_STREAM,
        streamParams: {
          moduleId,
        },
        itemsPerFetch: MESSAGES_PER_FETCH,
        items: result,
        entities,
        nextOffset: nextOffset || undefined,
        hasMore,
      }),
      payload: null /* stream intialize actions are not compatible with Action<any> */,
    },
  ];
};
